import alt from 'components/Dispatcher';
import AlbumActions from 'actions/AlbumActions';
import AlbumSource from 'sources/AlbumSource';

export class AlbumStore {
  constructor() {
    this.state = {
      first: 0,
      maxCount: 10,
      page: 0,
      userFirst: 0,
      userMaxCount: 5,
      mediasFirst: 0,
      mediasMaxCount: 10,
      albums: [],
      userAlbums: [],
      newAlbumName: '',
      newAlbumDesc: '',
      moreUserAlbum: true,
      moreAlbumMedias: true,
      postParam: {},
      loading: false,
      album_id: null,
      album: {},
      albumMedia: [],
      albumArticleMedia: [],
      totalPrice: 0,
      paySignature: '',
      offset: 0,
      articleOffset: 0,
      hasMore: true
    }
    this.registerAsync(AlbumSource);
    this.bindListeners({
      handleSetLoading: AlbumActions.SET_LOADING,
      handleFetchAlbumList: AlbumActions.FETCH_ALBUM_LIST,
      handleFetchUserAlbumList: AlbumActions.FETCH_USER_ALBUM_LIST,
      handleUpdateAlbumList: AlbumActions.UPDATE_ALBUM_LIST,
      handleUpdateUserAlbumList: AlbumActions.UPDATE_USER_ALBUM_LIST,
      handleAddAlbum: AlbumActions.ADD_ALBUM,
      handlePostAlbum: AlbumActions.POST_ALBUM,
      handleUpdateAlbum: AlbumActions.UPDATE_ALBUM,
      handleDeleteAlbum: AlbumActions.DELETE_ALBUM,
      handlePostAlbumAddMedia: AlbumActions.POST_ALBUM_ADD_MEDIA,
      handleCleanAlbumList: AlbumActions.CLEAN_ALBUM_LIST,
      handleCleanAlbumMedia: AlbumActions.CLEAN_ALBUM_MEDIA,
      handleFetchAlbumDetail: AlbumActions.FETCH_ALBUM_DETAIL,
      handleUpdateAlbumDetail: AlbumActions.UPDATE_ALBUM_DETAIL,
      handleFetchAlbumMedia: AlbumActions.FETCH_ALBUM_MEDIA,
      handleUpdateAlbumMedia: AlbumActions.UPDATE_ALBUM_MEDIA,
      handleFetchAlbumArticleMedia: AlbumActions.FETCH_ALBUM_ARTICLE_MEDIA,
      handleUpdateAlbumArticleMedia: AlbumActions.UPDATE_ALBUM_ARTICLE_MEDIA,
      handlePostCollectAlbum: AlbumActions.POST_COLLECT_ALBUM,
      handleUpdateIsCollect: AlbumActions.UPDATE_IS_COLLECT,
      handleUpdateOffset: AlbumActions.UPDATE_OFFSET,
      handleUpdateArticleOffset: AlbumActions.UPDATE_ARTICLE_OFFSET,
      handleUpdateFirst: AlbumActions.UPDATE_FIRST
    });
  }
  // 设置 loading 状态
  handleSetLoading(loading) {
    this.setState({loading: loading});
  }
  handleFetchAlbumList() {
    let first = 0;
    if(this.state.page) {
      first += (this.state.page - 1) * this.state.maxCount;
      if(this.state.albums.length){
        first += this.state.albums.length + 1;
      }else {
        first += 1;
      }
    }else{
      first = this.state.albums.length ? this.state.albums.length + 1 : 0;
    }
    this.setState({first: first, loading: true});
    this.getInstance().fetchAlbumList();
  }
  handleUpdateAlbumList(albums) {
    let more = albums.length === this.state.maxCount ? true : false
    let newAlbums = this.state.albums.concat(albums);
    this.setState({
      albums: newAlbums,
      loading: false,
      hasMore: more
    });
  }
  handleFetchUserAlbumList() {
    let first = this.state.userAlbums.length;
    this.setState({userFirst: first});
    this.getInstance().fetchUserAlbumList();
  }
  handleUpdateUserAlbumList(userAlbums) {
    let more = userAlbums.length === this.state.userMaxCount ? true : false
    let newUserAlbums = this.state.userAlbums.concat(userAlbums);
    this.setState({
      userAlbums: newUserAlbums,
      moreUserAlbum: more
    });
  }
  handleUpdateOffset(offset) {
    this.state.offset = offset;
  }
  handleUpdateArticleOffset(offset){
    this.state.articleOffset = offset;
  }
  handlePostAlbum(name) {
    this.setState({newAlbumName: name});
    this.getInstance().postAlbum();
  }
  handleUpdateAlbum(album) {
    this.setState({
      album_id: album.album_id,
      newAlbumName: album.name,
      newAlbumDesc: album.desc
    });
    this.getInstance().updateAlbum();
  }
  handleDeleteAlbum(id) {
    this.setState({album_id: id});
    this.getInstance().deleteAlbum();
  }
  handleAddAlbum(album) {
    let userAlbums = this.state.userAlbums;
    userAlbums.push(album);
    this.setState({userAlbums: userAlbums});
  }
  handlePostAlbumAddMedia(param) {
    this.setState({postParam: param});
    this.getInstance().postAlbumAddMedia();
  }
  handleCleanAlbumList() {
    this.setState({albums: []});
  }
  handleCleanAlbumMedia() {
    this.setState({albumMedia: []});
  }
  handleFetchAlbumDetail(id) {
    this.setState({album_id: id});
    this.getInstance().fetchAlbumDetail();
  }
  handleUpdateAlbumDetail(album) {
    this.setState({album: album});
  }
  handleFetchAlbumMedia(id) {
    let first = this.state.albumMedia.length + 1;
    this.setState({album_id: id,mediasFirst: first, loading: true});
    this.getInstance().fetchAlbumMedia();
  }
  handleFetchAlbumArticleMedia(id) {
    this.setState({album_id: id});
    this.getInstance().fetchAlbumArticleMedia();
  }
  handleUpdateAlbumMedia(medias) {
    let more = medias.length === this.state.mediasMaxCount? true : false
    let newAlbumMedias = this.state.albumMedia.concat(medias);
    this.setState({
      albumMedia: newAlbumMedias,
      loading: false,
      moreAlbumMedias: more
    });
  }
  handleUpdateAlbumArticleMedia(data) {
    this.setState({
      albumArticleMedia: data.medias,
      totalPrice: data.total_price,
      paySignature: data.pay_signature
    }); 
  }
  handlePostCollectAlbum(data) {
    this.setState({album_id: data.id});
    this.getInstance().postCollectAlbum();
  }
  handleUpdateIsCollect() {
    let album = this.state.album;
    if(album.isCollect) {
      album.isCollect = false;
    } else {
      album.isCollect = true;
    }
    this.setState({album: album});
  }
  handleUpdateFirst(page) {
    this.setState({page:page});
  }
}

export default alt.createStore(AlbumStore, 'AlbumStore');



// WEBPACK FOOTER //
// ./src/stores/AlbumStore.js